import React, { useState } from 'react';
import { AICreditsEditModal } from './AICreditsEditModal';
import { AICreditsBadge } from './AICreditsBadge';
import { useAiCreditsStore } from '../../../../stores/aiCreditsStore';
import type { MemberExtends } from '../../../../types/member';

interface AICreditsEditorProps {
  member: MemberExtends;
  onUpdate: (newCredits: number) => void;
}

export function AICreditsEditor({ member, onUpdate }: AICreditsEditorProps) {
  const [showEditModal, setShowEditModal] = useState(false);

  const handleUpdate = async (newCredits: number) => {
      try {
        // Update user_credits table directly
        await useAiCreditsStore.getState().setPlanCreditsForUser(member.id, newCredits);
        
        // Also update the local state for immediate UI feedback
        onUpdate(newCredits);
      } catch (error) {
        console.error('Error updating AI credits:', error);
      }
    setShowEditModal(false);
  };

  return (
    <>
      <button
        onClick={() => setShowEditModal(true)}
        className="group relative hover:opacity-75 transition-opacity"
      >
        <AICreditsBadge current={member.aiCredits} max={member.maxAiCredits} />
        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-5 rounded-full transition-colors" />
      </button>

      {showEditModal && (
        <AICreditsEditModal
          member={member}
          onUpdate={handleUpdate}
          onClose={() => setShowEditModal(false)}
        />
      )}
    </>
  );
}